import { JsonObject, JsonProperty } from 'json2typescript';

import { LearnCertType } from './learn-cert-type';

@JsonObject
export class LearnCertClass {

  /**
   * å®ä½id
   */
  @JsonProperty('id', Number, true)
  id: number = undefined;

  /**
   * åå»ºæ¶é´, æ¶é´æ³
   */
  @JsonProperty('createTime', Number, true)
  createTime: number = undefined;

  /**
   * æåä¿®æ¹æ¶é´, æ¶é´æ³
   */
  @JsonProperty('lastModified', Number, true)
  lastModified: number = undefined;

  @JsonProperty('name', String)
  name: string = undefined;

  @JsonProperty('tenantId', Number)
  tenantId: number = undefined;

  @JsonProperty('learnCertTypes', [LearnCertType], true)
  learnCertTypes: Array<LearnCertType> = [];

  @JsonProperty('idx', Number)
  idx: number = undefined;

  @JsonProperty('enabled', Boolean)
  enabled: boolean = undefined;

  // å­¦ä¹ å­æ®ç¦ç¨éç½®çæ è¯
  @JsonProperty('disabled', Boolean, true)
  disabled = false;

  static findClassByClassId(classId: number, classes: LearnCertClass[]): LearnCertClass {
    classes = classes || [];
    return classes.find(item => item.id === classId);
  }

  instanceOf(className: string): boolean {
    return 'LearnCertClass' === className;
  }

  getLearnCertTypeByTypeId(typeId: number): LearnCertType {
    // æªæ¾å°å°±è¿åundefined
    return this.learnCertTypes.find(type => type.id === typeId);
  }

}
